// src/components/ui/Card.js
import React from 'react';

const Card = ({ children, className = '', onClick, hover }) => (
  <div
    onClick={onClick}
    className={`bg-white dark:bg-gray-900 rounded-xl shadow-sm ${
      hover ? 'hover:shadow-xl hover:-translate-y-1 cursor-pointer' : ''
    } transition-all ${className}`}
  >
    {children}
  </div>
);

export default Card;
